import { mlHeaderMockData } from '@/components/molecules';
import frontDoorMockResponse from './data/frontdoor_mock_response.json';
import { EThemes } from '@/lib/contentstack-sdk/types';
import {
  THomePlansResponse,
  IOrHomePlansCarouselProps,
} from './or-home-plans-carousel.types';

import { EImagePosition } from '@/components/atoms/at-media/at-media.types';

export const planMetadataMocks = [
  {
    hpId: 'plan-001',
    image: {
      mobile_image_url: {
        filename: 'mobile1.jpg',
        url: 'https://example.com/mobile1.jpg',
        file_size: '150KB',
        is_dir: false,
        content_type: 'image/jpeg',
        parent_uid: null,
        tags: ['homepage', 'mobile'],
        dimension: {
          width: 750,
          height: 1334,
        },
        description: 'Mobile view of modern home exterior',
        uid: 'file-001',
        _content_type_uid: 'imageAsset',
      },
      mobile_aspect_ratio: '16:9',
      decorative: false,
      quality: 'high',
      priority: true,
      mobile_position: EImagePosition.CENTER,
      tablet_image_url: {
        filename: 'tablet1.jpg',
        url: 'https://example.com/tablet1.jpg',
        file_size: '200KB',
        is_dir: false,
        content_type: 'image/jpeg',
        parent_uid: null,
        dimension: {
          width: 1024,
          height: 768,
        },
        description: 'Tablet view of modern home exterior',
        uid: 'file-002',
        _content_type_uid: 'imageAsset',
      },
      tablet_aspect_ratio: '4:3',
      tablet_position: EImagePosition.LEFT,
      desktop_image_url: {
        filename: 'desktop1.jpg',
        url: 'https://example.com/desktop1.jpg',
        file_size: '300KB',
        is_dir: false,
        content_type: 'image/jpeg',
        parent_uid: null,
        dimension: {
          width: 1920,
          height: 1080,
        },
        description: 'Desktop view of modern home exterior',
        uid: 'file-003',
        _content_type_uid: 'imageAsset',
      },
      desktop_aspect_ratio: '16:9',
      desktop_position: EImagePosition.RIGHT,
    },
    exteriorStyleId: 'modern',
  },
  {
    hpId: 'plan-002',
    image: {
      mobile_image_url: {
        filename: 'mobile2.jpg',
        url: 'https://example.com/mobile2.jpg',
        file_size: '145KB',
        is_dir: false,
        content_type: 'image/jpeg',
        parent_uid: null,
        tags: ['alt-home', 'mobile'],
        dimension: {
          width: 750,
          height: 1000,
        },
        description: 'Cozy cottage mobile image',
        uid: 'file-004',
        _content_type_uid: 'imageAsset',
      },
      mobile_aspect_ratio: '3:2',
      decorative: true,
      quality: 'medium',
      priority: false,
      mobile_position: EImagePosition.LEFT,
    },
  },
];

export const homePlansMock =
  frontDoorMockResponse as unknown as THomePlansResponse;
export const trimmedHomePlansMock = homePlansMock.Plans.slice(0, 9);

export const orHomePlansCarouselMockData: IOrHomePlansCarouselProps = {
  heading: mlHeaderMockData,
  theme: EThemes.LIGHT,
  fullPlans: { Plans: trimmedHomePlansMock },
  planMetadata: planMetadataMocks,
};
